import React from 'react';

import { Alert } from '@mui/material';

import TenantTitleLink from '~/components/Users/UserDetails/TenantTitleLink';

import TENANTS from '~/consts/tenant';

import useCurrentTenant from '~/hooks/useCurrentTenant';

function getTenantByBrand(brand: string) {
  return Object.values(TENANTS).find((t) => t.brand === brand);
}

type Props = {
  brand: string;
};

export default function OrderBrandWarningMessage({ brand }: Props) {
  const { tenant } = useCurrentTenant();
  const orderTenant = getTenantByBrand(brand);

  if (tenant.brand === brand) {
    return null;
  }

  const orderBrandTitle = orderTenant?.title || brand;

  return (
    <Alert severity="warning" variant="standard" role="alert">
      Please note, this is not a <strong>{tenant.title}</strong> order. It was purchased on{' '}
      <strong>{orderBrandTitle}</strong>. Please switch to{' '}
      {orderTenant ? <TenantTitleLink tenant={orderTenant} /> : <strong>{orderBrandTitle}</strong>}.
    </Alert>
  );
}
